var exports = {
  "kL": "x31de4314--f7acf8--container",
  "iE": "x31de4314--f7acf8--wrapper",
  "DD": "x31de4314--f7acf8--title",
  "Qs": "x31de4314--f7acf8--content",
  "z5": "x31de4314--f7acf8--content-gallery",
  "L1": "x31de4314--f7acf8--content-title",
  "rr": "x31de4314--f7acf8--content-info",
  "IT": "x31de4314--f7acf8--content-main",
  "DE": "x31de4314--f7acf8--content-address",
  "F_": "x31de4314--f7acf8--content-description",
  "B8": "x31de4314--f7acf8--content-link",
};

module.exports = exports;
